module.exports = __webpack_public_path__ + "static/media/poliquel_ca_mg_b_mo.2d245282.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/nutricheck_foliar/poliquel_ca_mg_b_mo.png
// module id = 1306
// module chunks = 3